module.exports = __webpack_public_path__ + "static/media/ski-lift.86930711.svg";